import React from "react";
import styled from "styled-components";
import { Grid, BreadCrumbBox, Button, FilterWraper, Section } from "../../core";
import { MixStyle, theme } from "../../styles";
import { Link } from "react-router-dom";
import { Row } from "antd";
import ProgramHistory from "../../components/ProgramHistory";
import { useSizerData } from "../../hooks/useSizerData";
const { buttonBg } = theme;
const BtnProps = {
  width: "143px",
  height: "30px",
  margin: "5px",
  bg: buttonBg.tertiary,
};
const LinkBtn = styled(Link)`
  ${MixStyle.Link};
`;
const StyledBreadCrumb = styled(BreadCrumbBox)`
  ${MixStyle.flexArround}
`;
const SizerMain = () => {
  useSizerData();
  return (
    <Grid>
      <StyledBreadCrumb backlink={false} tittle="Program Status">
        <Row type="flex" justify="center">
          <Button {...BtnProps}>
            <LinkBtn to="/program-history">History</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="/add-sizer">Add Sizer</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="/send-yarn">Send Yarn</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="/add-program">Add Program</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="/pay-now">Generate Bill</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="/sizer-list">Sizer List</LinkBtn>
          </Button>
        </Row>
      </StyledBreadCrumb>
      <Section>
        <FilterWraper>
          <ProgramHistory />
        </FilterWraper>
      </Section>
    </Grid>
  );
};

export default SizerMain;
